export const modeKeys = {
  setable: 'setable',
  editable: 'editable',
  readable: 'readable',
};
